'use strict'
import {cl} from "./common";

let filterSettings = {};
let abortControllers = {};

document.addEventListener("DOMContentLoaded", function() {
	cl("Filters init");
	const filterModules = document.querySelectorAll(".filter-module");
	filterModules.forEach(filterModule => {
		const id = filterModule.getAttribute("data-id");
		filterSettings[id] = {'chunk': 1, 'filters': {}};;
		abortControllers[id] = new AbortController();
		updateFilterModule(filterModule, true);
		initFiltersEventHandlers(filterModule, id);
	});
});

function updateFilterModule(filterModule, reset = false) {

	const id = filterModule.getAttribute("data-id");
	const itemsPerChunk = filterModule.getAttribute('data-items-per-chunk');
	const preDefinedOptions = filterModule.getAttribute('data-options');

	if (reset) {
		filterSettings[id] = {'chunk': 1, 'filters': {}, 'items-per-chunk': itemsPerChunk, 'options': preDefinedOptions};
	}

	if (!abortControllers[id].signal.aborted) { abortControllers[id].abort(false); }
	abortControllers[id] = new AbortController();

	const filters = filterModule.querySelectorAll('*[data-filter-id]');

	if (filters.length > 0) {

		filters.forEach(filter => {
			const filterId = filter.getAttribute('data-filter-id');
			const filterType = filter.getAttribute('data-filter-type');
			let selectedOptions = filter.querySelectorAll('.selected, .active:not([data-value="*"])'); // Dropdown uses .selected, List uses .active

			if (selectedOptions.length == 0) { // Nothing selected, so every option should be used to filter
				selectedOptions = filter.querySelectorAll('.dropdown-item, .nav-item a'); // Dropdown uses .dropdown-item, List uses .nav-item a
			}

			let selection = [];
			selectedOptions.forEach(option => {
				selection.push(option.getAttribute("data-value"));
			});
			filterSettings[id]['filters'][filterId] = {'selection': selection, 'type': filterType};

		});

		let data = new FormData();
		data.append('action', 'filter');
		data.append('nonce', 'ajaxobj.nonce');
		data.append('id', id);
		data.append('filters', JSON.stringify(filterSettings[id]));

		if (reset) {
			filterModule.querySelector('.results').classList.add('loading');
			filterModule.querySelector('.filter-loading').classList.add('active');
		}

		fetch(ajaxobj.ajaxurl, {
			method: "POST",
			credentials: 'same-origin',
			signal: abortControllers[id].signal,
			body: data
		}).then(response => {
			return response.json();
		}).then(data => {
			filterModule.querySelector('.filter-loading').classList.remove('active');
			filterModule.querySelector('.results').classList.remove('loading');
			if (data.amount == 0) {
				filterModule.querySelector('.nothing-found').classList.add('active');
			} else {
				filterModule.querySelector('.nothing-found').classList.remove('active');
			}
			const loadMoreButton = filterModule.querySelector('.load-more');
			if (loadMoreButton) { loadMoreButton.remove(); }
			if (reset) {
				filterModule.querySelector('.results').innerHTML = data.results;
			} else {
				filterModule.querySelector('.results').insertAdjacentHTML("beforeend", data.results);
			}
			initResultsEventHandlers(filterModule, id);
		}).catch(error => {
			console.log(error);
		});
	}
}

function initFiltersEventHandlers(filterModule, id) {

	// Dropdown?
	const dropdownItems = filterModule.querySelectorAll('.dropdown-item');
	if (dropdownItems) {
		dropdownItems.forEach(item => {
			item.addEventListener('click', function(ev) {
				if (item.classList.contains('selected')) {
					item.classList.remove('selected');
				} else {
					item.classList.add('selected');
				}
				ev.stopPropagation();
				updateFilterStatus(item);
				updateFilterModule(filterModule, true);
			})
		});
	}

	// List?
	const listItems = filterModule.querySelectorAll('.nav-item');
	if (listItems) {
		listItems.forEach(item => {
			item.addEventListener('click', function(ev) {
				listItems.forEach(item => {
					item.querySelector('a').classList.remove('active');
				});
				item.querySelector('a').classList.add('active');
				updateFilterModule(filterModule, true);
			})
		});
	}

}

function initResultsEventHandlers(filterModule, id) {

	const loadMoreButton = filterModule.querySelector('.load-more');
	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', function(ev) {
			filterSettings[id]['chunk']++;
			loadMoreButton.setAttribute('disabled', 'disabled');
			updateFilterModule(filterModule);
		});
	}

	const selectionTags = filterModule.querySelectorAll('.selection-tag');
	selectionTags.forEach(tag => {
		tag.querySelector('.close-button').addEventListener('click', function(ev) {
			const filterId = tag.getAttribute("data-filter-id");
			const value = tag.getAttribute("data-value");
			const item = filterModule.querySelector('li[data-filter-id="'+filterId+'"] div[data-value="'+value+'"]');
			if (item) {
				item.classList.remove("selected");
				updateFilterStatus(item);
			}
			updateFilterModule(filterModule, true);
		});
	});

}

function updateFilterStatus(item) {
	const filter = item.closest('.dropdown-attr-filter');
	if (filter.querySelector('.dropdown-item.selected')) {
		filter.classList.add('active');
	} else {
		filter.classList.remove('active');
	}
}
